import React from "react";
import SvgRightCaret from "../../../../assets/icons/SvgRightCaret";
import { Link } from "gatsby";

export default function MenuLink({ title, showCaretIcon, to, otherProps }) {
  return (
    <Link
      className="cursor-pointer font-medium text-xl py-[10px] flex justify-between items-center outline-none focus:outline-none no-underline text-white hover:text-secondary-500"
      to={to}
      {...otherProps}
    >
      {title}
      {(typeof showCaretIcon === "undefined" ? true : showCaretIcon) && (
        <SvgRightCaret
          style={{
            width: "12px",
            height: "12px",
            transform: "rotate(270deg)",
          }}
        />
      )}
    </Link>
  );
}
export function MenuButton({ title, showCaretIcon, onClick, otherProps }) {
  return (
    <button
      className="cursor-pointer font-medium text-xl py-[10px] flex justify-between items-center outline-none focus:outline-none"
      role="button"
      onClick={onClick}
      {...otherProps}
    >
      {title}
      {(typeof showCaretIcon === "undefined" ? true : showCaretIcon) && (
        <SvgRightCaret
          style={{
            width: "12px",
            height: "12px",
            transform: "rotate(270deg)",
          }}
        />
      )}
    </button>
  );
}
